import React from 'react';
import Loadable from 'Shared/Loadable';
import Loader from './ui/Loader';

const LazyShoppingCartPopup = props => (
  <Loadable
    Loader={<Loader />}
    module={() =>
      import(
        /* webpackChunkName: "shopping-cart-popup" */ './containers/WithProductsContext'
      )
    }
    {...props}
  />
);

export default LazyShoppingCartPopup;
